import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { trimObjectStrings } from 'utils'
import Edit from './edit'
import { fetch, update, edit, remove, lookup, saveTemporary } from '../../actions'
import { fetch as fetchContract } from 'features/fleet/actions'

/* ---------- Wrapper ---------- */

const EditContainer = (props) => {
  const { id } = useParams()
  return <ConnectedEdit {...props} routeId={id} />
}

/* ---------- Redux ---------- */

const mapStateToProps = ({ drivers, settings }, { routeId }) => ({
  id: routeId,
  data: trimObjectStrings(drivers.data?.[routeId]),
  flags: drivers.flags,
  fleetIds: settings.fleet.selected,
  apiResponse: drivers.apiResponse,
  userRoles: settings.roles
})

const mapDispatchToProps = (dispatch) => ({
  onFetch: (agreementNo, fleetIds) => {
    const FleetId = fleetIds.join(',')
    dispatch(fetch(null, {
      resourceId: agreementNo,
      queryParams: { FleetId }
    }))
  },
  onFetchContract: (agreementNo, fleetId) => {
    dispatch(fetchContract(null, {
      resourceId: agreementNo,
      queryParams: { fleetId }
    }))
  },
  onUpdate: (uniqueId, payload) =>
    dispatch(update(payload, { resourceId: uniqueId })),
  onChange: (payload) => dispatch(edit(payload)),
  onRemove: (uniqueId) =>
    dispatch(remove(null, { resourceId: uniqueId })),
  onLookup: (lookupPath, searchKey, customFleetId, size = 100) =>
    dispatch(lookup(null, {
      resourceId: lookupPath,
      queryParams: { FleetId: customFleetId, Search: searchKey, size }
    })),
  onSaveTemporary: (payload) => dispatch(saveTemporary(payload))
})

const ConnectedEdit = connect(
  mapStateToProps,
  mapDispatchToProps
)(Edit)

export default EditContainer
